export default "__VITE_ASSET__BlmZM8S8__"